export default __webpack_public_path__ + "static/global-filters-light-mode-b1bbc4c67178a45e647328ca0add089a.png";